export default "__VITE_ASSET__C2dcZbZS__ 1200w";